import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "button"]
  static values = { copied: { type: String, default: "Copiado!" } }

  async copy() {
    const text = this.hasSourceTarget ? (this.sourceTarget.value || this.sourceTarget.textContent) : this.element.dataset.clipboardText
    try {
      await navigator.clipboard.writeText(text.trim())
      const original = this.buttonTarget.textContent
      this.buttonTarget.textContent = this.copiedValue
      setTimeout(() => (this.buttonTarget.textContent = original), 1500)
    } catch (_e) {
      this.sourceTarget.select?.()
    }
  }
}
